export enum DashboardViewMode {
	VIEW_AS = 'viewAs',
	NORMAL = 'normal'
}